<template>
  <div class="game-life">
    <div class="game-life__circle" data-circle>
      <img src="/img/misc/life-icon.png" alt="Game life icon" data-icon>
    </div>

    <p class="game-life__text" v-html="$store.state.life"/>
  </div>
</template>

<script>
export default {
  name: 'GameLife',
};
</script>

<style lang="scss" scoped>
.game-life {
  position: relative;

  &__circle {
    width: 55px;
    height: 55px;

    border-radius: 50%;
    background-color: $color-yellow;
    box-shadow: $button-shadow;

    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 70%;
    }
  }

  &__text {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: 2px;

    font-size: 18px;
    transform: translate(-50%, -50%);
  }

  @include mq($until: mobileL) {
    &__circle {
      width: 35px;
      height: 35px;
    }

    &__text {
      margin-top: 1px;

      font-size: 11px;
      font-weight: bold;
    }
  }
}
</style>
